module.exports = __webpack_public_path__ + "img/icon-terms.23c022c7.svg";